<template>
  <div class="p-3">
    <b-row>
      <b-col cols="3">
        <div class="sg-badge" :class="getActiveSetting('pending_customer')" @click="showPendingPayment">
          <font-awesome-icon icon="flag" /> Awaiting Payment
        </div>
      </b-col>
      <b-col cols="3">
        <div class="sg-badge" :class="getActiveSetting('failed')" @click="showFailedPayment">
          <font-awesome-icon icon="flag" /> Failed Payment
        </div>
      </b-col>

      <b-col cols="2">
        <div class="sg-badge" :class="getActiveSetting('paid')" @click="showPaidPayment">
          <font-awesome-icon icon="history" /> History
        </div>
      </b-col>
    </b-row>

    <b-row class="p-3">
      <b-col>
        <b-table
          hover
          striped
          show-empty
          stacked="md"

          :items="payment_arr"
          :fields="payment_column"
        >
          <template v-slot:cell(actions)="row">
            <b-button v-if="(row.item.status === 'Unpaid' || row.item.status === 'Failed')" size="sm" variant="success" @click="confirmPayment(row.item)">
              <font-awesome-icon icon="upload" /> Upload Receipt
            </b-button>
            <b-button v-if="row.item.status === 'Paid'" size="sm" @click="viewReceipt(row.item)">
              <font-awesome-icon icon="pencil-alt" /> View Receipt
            </b-button>
            <b-button v-if="row.item.status === 'Pending Admin'" size="sm" disabled>
              Waiting for Admin Confirmation
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <br>
    <p v-if="payment_body === 'failed'"><i><b>*Admin has failed your payment, please upload again</b></i></p>

  </div>
</template>

<script>
// external dependencies
import moment from 'moment'

// custom component

// api call
import PaymentAPI from '@/api/PaymentAPI'

export default {
  name: 'MyAccount_Payment',
  components: {
  },
  props: ['user'],
  data () {
    return {
      payment_body: '',

      payment_arr: [],
      payment_column: [
        { key: 'payment_id', label: 'Payment ID' },
        { key: 'order_id', label: 'Order ID' },
        { key: 'amount', label: 'Amount' },
        { key: 'status', label: 'Status' },
        { key: 'transaction_date', label: 'Date' },
        { key: 'actions', label: '', class: 'text-center' }
      ]
    }
  },
  created: function () {
    this.showPendingPayment()
  },
  methods: {
    // PREREQUISITES
    getActiveSetting: function (property) {
      return {
        'on': property === this.payment_body
      }
    },
    showPendingPayment: function () {
      this.payment_body = 'pending_customer'
      let status = [{status: `pending_customer`}, {status: `pending_admin`}]
      this.fetchPaymentList({
        select: 'payment_id tgbs_order_id currency price status transaction_date',
        query: {
          is_delete: false,
          sg_user_id: this.user._id,
          $or: status,
          tgbs_order_id: { $ne: null }
        }
      })
    },
    showFailedPayment: function () {
      this.payment_body = 'failed'

      this.fetchPaymentList({
        select: 'payment_id tgbs_order_id currency price status transaction_date',
        query: {
          is_delete: false,
          sg_user_id: this.user._id,
          status: 'failed',
          tgbs_order_id: { $ne: null }
        }
      })
    },
    showPaidPayment: function () {
      this.payment_body = 'paid'

      this.fetchPaymentList({
        select: 'payment_id tgbs_order_id currency price status transaction_date',
        query: {
          is_delete: false,
          sg_user_id: this.user._id,
          status: 'paid',
          tgbs_order_id: { $ne: null }
        }
      })
    },
    toMoney: function (int) {
      if (int) return int.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
    },
    confirmPayment: function (rowItem) {
      this.$router.push({
        name: 'Pay_Confirmation',
        params: {
          payment_id: rowItem._id
        }
      })
    },
    viewReceipt: function (rowItem) {
    },
    // END PREREQUISITES

    // HTTP REQUEST
    fetchPaymentList: async function (param) {
      try {
        const response = await PaymentAPI.fetchPaymentList(param)
        this.payment_arr = []

        response.data.payments.forEach(x => {
          this.payment_arr.push({
            _id: x._id,
            payment_id: x.payment_id,
            order_id: x.order_id,
            amount: `${x.currency} ${this.toMoney(x.price)}`,
            status: x.status === 'pending_customer' ? 'Unpaid' : (x.status === 'paid') ? 'Paid' : x.status === 'failed' ? 'Failed' : x.status === 'pending_admin' ? 'Pending Admin' : '-',
            transaction_date: moment(x.transaction_date).format('ll')
          })
        })
      } catch (error) {
        console.log(error)
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-badge {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MyAccount/Payment/Payment.vue